var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"signin"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"center"},[_c('router-link',{attrs:{"to":{ name: 'top' }}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/logo.png")}})])],1),_c('sign-in-connected-account-form',{attrs:{"propEmail":_vm.email}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }